import { CheckoutSteps } from "context";
import { useTranslation } from "next-i18next";
import LinkComponent from "@Components/Link";
import { localeSelector } from "@wff/store/localeSlice";
import { useAppSelector } from "store/hooks";
import { KEYS_CART } from "../translation-keys";
import classes from "./CartDrawerFooter.module.scss";

interface CartDrawerFooterProps {
  showFooter: boolean;
  disableCheckout: boolean;
}

function CartDrawerFooter(props: CartDrawerFooterProps) {
  const { showFooter, disableCheckout } = props;
  const { t } = useTranslation("common");
  const locale = useAppSelector(localeSelector);
  return (
    (showFooter && (
      <div className={classes["cart-flyout__footer"]}>
        <div className={classes["cart-flyout__footer-container"]}>
          <LinkComponent
            href={`/${locale.languageCode}/checkout?step=${CheckoutSteps.auth}`}
          >
            <a
              className={`${classes["cart-flyout__footer-button"]} ${
                classes.action
              } ${disableCheckout && classes.pointer}`}
            >
              {t(KEYS_CART.general.checkout)}
            </a>
          </LinkComponent>
        </div>
        {/** TO DO :- Not yet Implemented  */}
        {/* <div className={classes["cart-flyout__spend"]}>
          <div className={classes["cart-flyout__overlay"]}>
            {t("cart.general.spend_amount").replace("{{amount}}", `$103.04`)}
          </div>
        </div> */}
      </div>
    )) || <></>
  );
}

export default CartDrawerFooter;
